import moment from 'moment'
const _ = require('lodash')

const getTime = (time) => time ? +moment(time) : null

export function getTimeLine(data) {
  const {
    createdTime,
    senderDeliveryTime,
    rejectAppraisalTime,
    receiptTime,
    firstAppraisalTime,
    secondAppraisalTime,
    thirdAppraisalTime,
    appraisalAckTime,
    appraisalCheckTime,
    appraisalDeliveryTime,
    checkinTime,
    appraisalReviewTime } = data
  const timeLine = [
    { label: '商家提交委托单', time: getTime(createdTime) },
    { label: '商家发货', time: getTime(senderDeliveryTime) },
    { label: '到货时间', time: getTime(checkinTime) },
    { label: '鉴定中心收货', time: getTime(receiptTime) },
    { label: '鉴定中心拒绝鉴定', time: getTime(rejectAppraisalTime) },
    { label: '初审鉴定完成', time: getTime(firstAppraisalTime) },
    { label: '初审2鉴定完成', time: getTime(secondAppraisalTime) },
    { label: '初审3鉴定完成', time: getTime(thirdAppraisalTime) },
    { label: '复审鉴定完成', time: getTime(appraisalAckTime) },
    { label: '管理员审核完成', time: getTime(appraisalReviewTime) },
    { label: '校对员校对完成', time: getTime(appraisalCheckTime) },
    { label: '中心回寄商品', time: getTime(appraisalDeliveryTime) }
  ]
  return _.sortBy(timeLine.filter(i => !!i.time), i => i.time)
}
